"use client";

import { useEffect } from "react";
import { useSearchParams } from "next/navigation";

export function TiktokPixelCookieSetter(): null {
  const searchParams = useSearchParams();

  useEffect(() => {
    const ttclid = searchParams.get("ttclid");
    if (ttclid) {
      const expires = new Date();
      expires.setDate(expires.getDate() + 90);
      document.cookie = `ttclid=${encodeURIComponent(ttclid)}; expires=${expires.toUTCString()}; path=/; SameSite=Lax; Secure`;
    }
  }, [searchParams]);

  return null; // This component does not render anything
}
